<div class="hunt-details-editor-wrapper">
    <div class="title">
        <hyperkit-typography [variant]="variant">{{ title }}</hyperkit-typography>
    </div>
    <hyperkit-editor [value]="value" (valueChange)="onEditorValueChange($event)"></hyperkit-editor>
</div>